export default __webpack_public_path__ + "static/media/icn-gear-active.06bdbe84.svg";